export const cityMapper={
بغداد:"Baghdad",
سبوت:"Baghdad",
FTTH:"Baghdad",
Spot:"Baghdad",

}